export const scrollTop = (behavior: ScrollBehavior = "smooth") => {
  window.scrollTo({ top: 0, left: 0, behavior });
};

export const scrollTableTop = (behavior: ScrollBehavior = "smooth") => {
  const tables = document.getElementsByClassName("table");
  if (tables.length) {
    tables[0].scrollIntoView({ block: "start", inline: "nearest", behavior });
  }
};

export const scrollModalTop = (behavior: ScrollBehavior = "smooth") => {
  const modalBodies = document.getElementsByClassName("modal-body");
  if (modalBodies.length) {
    modalBodies[0].scroll({ top: 0, left: 0, behavior });
  }
};
